function OTAIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 80 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.951 17.727l-.824-2.334-6.994-9.348 1.256-.312 12.06 10.425 7.097-2.03c.834-.215 1.782-.262 2.503-.257-2.23-4.81-6.312-8.759-11.701-10.678C16.695-.603 4.981 4.963 1.192 15.621a20.385 20.385 0 00-.96 9.932l17.002-5.907 6.717-1.92zM39.796 15.714c-.623.405-1.539.935-2.447 1.227l-7.112 2.03-4.746 15.235-1.232.4 1.001-11.635-.56-2.417-6.665 1.902L.42 26.603c1.394 6.78 6.194 12.685 13.19 15.179 10.656 3.796 22.365-1.772 26.154-12.423a20.405 20.405 0 00.032-13.645z"
        fill="#072F54"
      />
      <path
        d="M24.7 20.556l.562 2.414-1.003 11.636 1.232-.4 4.746-15.233 7.112-2.03c.908-.292 1.823-.827 2.447-1.227a20.64 20.64 0 00-.746-1.843c-.722-.005-1.67.044-2.503.255l-7.098 2.035-12.062-10.43-1.254.314 6.992 9.348.827 2.331-6.72 1.924-17 5.902c.055.354.116.704.187 1.053l17.619-4.148 6.662-1.901z"
        fill="#FBC108"
      />
      <path
        d="M35.207 42.955v.718h35.206a8.622 8.622 0 008.622-8.622V9.904a8.622 8.622 0 00-8.622-8.623H43.83a8.622 8.622 0 00-8.622 8.623v33.05z"
        fill="#C4C4C4"
        stroke="#fff"
        strokeWidth={1.437}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.292 9.863c0-4.34-3.566-7.863-7.957-7.863H43.882c-4.39 0-7.957 3.523-7.957 7.863v25.229c0 4.338 3.567 7.863 7.957 7.863h26.453c4.391 0 7.958-3.525 7.958-7.863V9.863z"
        fill="#0C3B7C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.926 27.443h21.16v15.511h-21.16V27.443z"
        fill="#0C3B7C"
      />
      <path
        d="M55.18 29.107l-3.412-.003v-4.033c0-.862.338-1.31 1.084-1.413h2.328c1.66 0 2.735 1.035 2.735 2.71 0 1.72-1.047 2.738-2.735 2.74zM51.768 18.23v-1.062c0-.929.398-1.37 1.27-1.428h1.746c1.498 0 2.395.885 2.395 2.369 0 1.128-.615 2.447-2.34 2.447h-3.071V18.23zm7.77 4.024l-.617-.343.538-.455c.627-.532 1.678-1.73 1.678-3.796 0-3.164-2.483-5.205-6.325-5.205h-4.385v-.002h-.5c-1.138.042-2.05.958-2.063 2.09v17.956h7.034c4.27 0 7.027-2.298 7.027-5.857 0-1.917-.89-3.555-2.387-4.388z"
        fill="#fff"
      />
    </svg>
  )
}

export default OTAIcon
